import { legoInit, legoPerf } from '@zz-common/lego'

// babel core-js@3
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import '@zz/sasscore/flexible.js'
import VueLazyLoad from 'vue-lazyload'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import { SentryVueInit } from '@zz-common/sentry'
import { initDownload } from './utils/index.js'
initDownload()
Vue.config.productionTip = false
class __App__ {
  init() {
    tryCatch(() => {
      // 全局初始化乐高埋点的值，默认合入backup
      legoInit()
      legoPerf()
      // js异常上报
      if (process.env.NODE_ENV === 'production') {
        SentryVueInit('https://aac1d241f2ad4724857981316277e12f@sentry.zhuanzhuan.com/1618', {
          ignoreErrors: [
            // 可忽略的关键字枚举，这个会和脚本库默认的忽略范围merge
            "undefined is not an object (evaluating 'window.webkit.messageHandlers')",
            'downProgCallback is not defined',
            'syncDownloadState is not defined',
            'baiduInputJSBridge is not defined',
            'v is not defined',
            'checkLogin is not defined',
            'insertStyle is not defined'
          ],
        })
      }
    })
    // 懒加载
    this.sueLazyLoad()
    // 注册vue实例
    this.mount()
  }

  mount() {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }

  sueLazyLoad() {
    tryCatch(function() {
      Vue.use(VueLazyLoad, {
        preLoad: 1.3,
        try: 2,
        error: require('./assets/img/loading.svg'),
        loading: require('./assets/img/loading.svg')
      })
    })
  }
}

const app = new __App__()
app.init()

function tryCatch(fn) {
  try {
    fn()
  } catch (err) {
    console.error(err)
  }
}
